import { useState } from "react";
import { 
  createUserWithEmailAndPassword, 
  sendEmailVerification, 
  GoogleAuthProvider, 
  OAuthProvider, 
  signInWithPopup,
  signOut 
} from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import styles from "./Signup.module.css";

export default function Signup() {
  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const navigate = useNavigate();

  const signup = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    if (!name || !dob || !email || !password) {
      setErrorMsg("Please fill all fields");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // ⭐ Save Name + DOB in Firestore
      await setDoc(doc(db, "users", user.uid), {
        name,
        dob,
        email,
        createdAt: new Date()
      });

      await sendEmailVerification(user);
      await signOut(auth);

      setSuccessMsg(
        "Signup successful! A verification email has been sent. Please verify your email before logging in."
      );

      setName("");
      setDob("");
      setEmail("");
      setPassword("");

      setTimeout(() => navigate("/login"), 5000);

    } catch (err) {
      setErrorMsg(err.message);
    }
  };

  const handleGoogleSignup = async () => {
    const provider = new GoogleAuthProvider();
    setErrorMsg("");

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // ⭐ Save Google user info
      await setDoc(doc(db, "users", user.uid), {
        name: user.displayName || "",
        dob: "",
        email: user.email,
        createdAt: new Date()
      });

      navigate("/dashboard");
    } catch (err) {
      setErrorMsg(err.message);
    }
  };

  const handleAppleSignup = async () => {
    const provider = new OAuthProvider("apple.com");
    setErrorMsg("");

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      await setDoc(doc(db, "users", user.uid), {
        name: user.displayName || "",
        dob: "",
        email: user.email,
        createdAt: new Date()
      });

      navigate("/dashboard");
    } catch (err) {
      setErrorMsg(err.message);
    }
  };

  return (
    <div className={styles.signupPage}>
      <div className={styles.signupBox}>
        <h2 className={styles.title}>Create Your Account</h2>

        <form onSubmit={signup} className={styles.form}>

          <input
            type="text"
            placeholder="Full Name"
            value={name}
            className={styles.input}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <input
            type="date"
            placeholder="Date of Birth"
            value={dob}
            className={styles.input}
            onChange={(e) => setDob(e.target.value)}
            required
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            className={styles.input}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            className={styles.input}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
          />

          <button type="submit" className={styles.signupButton}>
            Sign Up
          </button>

          {errorMsg && <p className={styles.errorMsg}>{errorMsg}</p>}
          {successMsg && <p className={styles.successMsg}>{successMsg}</p>}

          <div className={styles.socialBackRow}>
            <button
              type="button"
              className={styles.googleBtn}
              onClick={handleGoogleSignup}
            >
              via Google
            </button>

            <button
              type="button"
              className={styles.appleBtn}
              onClick={handleAppleSignup}
            >
              via Apple
            </button>

            <button
              type="button"
              className={styles.btnBack}
              onClick={() => navigate(-1)}
            >
              Go Back
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
